import { cn } from '@/utils/cn'

/** Estilo base compartilhado por Input, Select e Textarea. */
export const baseControl =
  'h-10 w-full rounded-lg border bg-surface px-3 text-sm text-fg placeholder:text-fg-subtle ' +
  'transition-colors focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-brand ' +
  'disabled:cursor-not-allowed disabled:opacity-60'

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger'
export type ButtonSize = 'sm' | 'md' | 'lg'

const VARIANTS: Record<ButtonVariant, string> = {
  primary: 'bg-brand text-white hover:bg-brand-strong',
  secondary: 'bg-brand-deep text-white hover:bg-brand-strong',
  outline: 'border border-line bg-surface text-fg hover:bg-surface-2',
  ghost: 'text-fg-muted hover:bg-surface-2 hover:text-fg',
  danger: 'bg-critical text-white hover:brightness-95',
}

const SIZES: Record<ButtonSize, string> = {
  sm: 'h-8 px-3 text-sm',
  md: 'h-10 px-4 text-sm',
  lg: 'h-11 px-5 text-[0.95rem]',
}

interface ButtonClassOptions {
  variant?: ButtonVariant
  size?: ButtonSize
  fullWidth?: boolean
}

/** Classe compartilhada entre <Button> e links com aparência de botão. */
export function buttonClass({
  variant = 'primary',
  size = 'md',
  fullWidth,
}: ButtonClassOptions = {}) {
  return cn(
    'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand',
    'disabled:pointer-events-none disabled:opacity-50',
    VARIANTS[variant],
    SIZES[size],
    fullWidth && 'w-full',
  )
}
